export enum OptionGroupType {
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
}
